export const SET_THEME: string = 'SET_THEME';
